"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.signIn = void 0;
const react_1 = require("next-auth/react");
const get_cached_session_store_1 = require("./utils/get-cached-session-store");
/**
 * Call next-auth signIn and clear the cached session.
 *
 * Client-side method to initiate a signin flow or send the user to the signin page listing all possible providers. Automatically adds the CSRF token to the request.
 * [Documentation](https://next-auth.js.org/getting-started/client#signin)
 * @param {...any} args
 */
const signIn = (...args) => {
    (0, get_cached_session_store_1.clearCachedSession)(); // Clear cache on sign in to prevent cross contamination
    return (0, react_1.signIn)(...args);
};
exports.signIn = signIn;
